import React, { Component } from 'react';
import { translate } from 'react-i18next';
import Markdown from 'react-remarkable';
import '../components/input/input.css'
import './resources.css'

import { graphql, compose } from 'react-apollo'
import { submitFeedback } from "../graphql/mutations.js"
import { notifyResults } from "../graphql/mutations.js"
import { withCookies } from 'react-cookie';
import { parse } from 'qs';

import AnchorLink from 'react-anchor-link-smooth-scroll'
import Input, { InputAdornment } from 'material-ui/Input';
import Send from 'material-ui-icons/Send';
import IconButton from 'material-ui/IconButton';

// var Markdown = require('react-remarkable');

class ResourcePage extends Component {

  state = {
    sessionId: '',
    emailMenuToggled: false,
    email: '',
    feedback: '',
  }

  markdownOptions = {
    linkTarget: '_blank'
  }

  constructor(props) {
    super(props)

    console.log(props)

    let lang = this.props.match.params.lang
    if (lang) {
      this.props.i18n.changeLanguage(lang)
    }

    let urlSession = parse(props.location.search, {ignoreQueryPrefix: true}).id
    let cookieSession = props.cookies.get("session_cookie") && props.cookies.get("session_cookie").session_id

    this.state.sessionId = urlSession || cookieSession

    console.log(this.state)
      
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  notifyResults = event => {
    event.preventDefault()
    this.props.notifyResults({ email: this.state.email, sessionId: this.state.sessionId })
      .then(({ data, errors }) => {
        console.log("RESULTS NOTIFIED", data, errors)
        let errorMsg = ""
        if (errors && errors[0]) errorMsg = errors[0].message

        if (errorMsg) {
          this.setState({emailError: errorMsg})
        } else {
          this.setState({emailSent: true, emailError: ''})
          
          setTimeout(e => {
            this.setState({ email: '', emailSent: false, emailMenuToggled: false })
          }, 1250)
        }
      })
      .catch((error) => {
        console.error("ERROR!", error.message)
        console.log(error.name)
        this.setState({emailError: error.message})
      })
  }

  submitFeedback = event => {
    event.preventDefault()
    let feedback = this.state.feedback_q1 + '\n' + this.state.feedback_q2 + '\n' + this.state.feedback_q3
    this.props.submitFeedback({ feedback: feedback, sessionId: this.state.sessionId })
      .then(({ data, errors }) => {
        console.log("FEEDBACK SUBMITTED", data, errors)
        let errorMsg = ""
        if (errors && errors[0]) errorMsg = errors[0].message

        if (errorMsg) {
          this.setState({feedbackError: errorMsg})
        } else {
          this.setState({feedbackSuccess: true, feedbackError: '', feedback: '', feedback_q1: '', feedback_q2: '', feedback_q3: ''})
        }
      })
      .catch((error) => {
        console.error("ERROR!", error.message)
        console.log(error.name)
        this.setState({feedbackError: error.message})
      })
  }

  submitVolunteer = event => {
    event.preventDefault()
    let request = "(interested to volunteer with TBP)\n\n" + this.state.name + "\n" + this.state.contact
    this.props.submitFeedback({ feedback: request, sessionId: this.state.sessionId })
      .then(({ data, errors }) => {
        console.log("VOLUNTEER SUBMITTED", data, errors)
        let errorMsg = ""
        if (errors && errors[0]) errorMsg = errors[0].message

        if (errorMsg) {
          this.setState({volunteerError: errorMsg})
        } else {
          this.setState({volunteerSuccess: true, volunteerError: '', name: '', contact: ''})
        }
      })
      .catch((error) => {
        console.error("ERROR!", error.message)
        console.log(error.name)
        this.setState({volunteerError: error.message})
      })
  }

  render() {
    const { t, i18n } = this.props

    let region = this.props.match.params.region || ''

    let overviewBlocks = [
      'support-block',
      'feedback-block'
    ]

    let supportBlocks = [
      'chat-block',
      'reading-block',
      'helpline-block',
      'suicide-block',
    ]

    return (
      <div className="resources-frame">
        <h1>
          {t(region + ':resources.page-title')}
        </h1>

        <div className="box-container">
          {
            overviewBlocks.map(tag => (
              <div className="resources-box" key={tag}>
                <h3>
                  {t(region + ':resources.' + tag + '.title')}
                </h3>
                <p>
                  <strong>
                    {t(region + ':resources.' + tag + '.body')}
                  </strong>
                </p>
                <AnchorLink href={'#' + tag} 
                  onClick={(e) => {
                      this.props.history.push(
                        Object.assign({}, this.props.location, { hash: tag })
                      )
                    }}>
                  <button className="resources-button">
                    {t(region + ':resources.' + tag + '.action')}
                  </button>
                </AnchorLink>
              </div>
            ))
          }
        </div>

        <div className="support-section-arrow">
          <div className="left" />
          <div className="right" />
        </div>

        <div className="support-section" id="support-block">
          <h1>
            <strong>
              {t(region + ':resources.support-section.title')}
            </strong>
          </h1>
          <p className="subtitle">
            <strong>
              {t(region + ':resources.support-section.subtitle')}
            </strong>
          </p>

          <button className="resources-button small" 
            onClick={e => {this.setState({ emailMenuToggled: !this.state.emailMenuToggled})}}>
            {t(region + ':resources.support-section.email-me-button')}
          </button>

          { this.state.emailMenuToggled &&
            <div>
              <div className="popout-arrow">
                <div className="left" />
                <div className="right" />
              </div>
              <div className="popout-container">
                { t(region + ':resources.support-section.email-me-description') }
                { this.state.emailSent && 
                  <div className="success-notification">
                    {t(region + ':resources.support-section.email-sent')}
                  </div>
                }
                { this.state.emailError && 
                  <div className="error-notification">
                    {this.state.emailError}
                  </div>
                }
                <form onSubmit={this.notifyResults}>
                  <div className="text-input-container">
                    <Input
                      placeholder={ t(region + ':resources.support-section.email-me-placeholder') }
                      value={this.state.email}
                      onChange={this.handleChange('email')}
                      fullWidth
                      required
                      type='email'
                      autoComplete='email'
                      endAdornment={
                        <InputAdornment position="end" >
                          <IconButton color="primary" type="submit" disabled={!this.state.email}>
                            <Send />
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </div>
                  { this.state.feedbackError &&
                    <div className="error-notification">
                      {this.state.feedbackError}
                    </div>
                  }
                </form>
              </div>
            </div>
          }
          
          <div className="box-container">
            {
              supportBlocks.map(tag => (
                <div className="resources-box left" key={tag}>
                  <h2 className={tag}>
                    <strong>
                      {t(region + ':resources.support-section.' + tag + '.title')}
                    </strong>
                  </h2>
                  { i18n.exists(region + ':resources.support-section.' + tag + '.subtitle') &&
                    <p>
                      <strong>
                        { t(region + ':resources.support-section.' + tag + '.subtitle')}
                      </strong>
                    </p>
                  }
                  <Markdown source={t(region + ':resources.support-section.' + tag + '.body')} options={this.markdownOptions}/>
                </div>
              ))
            }
          </div>
          
        </div>

        <div className="feedback-section" id="feedback-block">
          <h1>
            {t(region + ':resources.feedback-section.title')}
          </h1>
          <p>
            {t(region + ':resources.feedback-section.subtitle')}
          </p>
          <br/>
          <div className="form-container">
            <form onSubmit={this.submitFeedback}>
              <p>
                <strong>
                  {t(region + ':resources.feedback-section.question-one')}
                </strong>
              </p>
              <div className="text-input-container margin-bottom">
                <Input
                  // placeholder={t(region + ':resources.feedback-section.question-one')}
                  multiline
                  fullWidth
                  value={this.state.feedback_q1}
                  onChange={this.handleChange('feedback_q1')}
                  rows={6}
                  classes={{root: "text-input-root"}}
                  // style={{ width: '100%'}}
                  >
                </Input>
              </div>

              <p>
                <strong>
                  {t(region + ':resources.feedback-section.question-two')}
                </strong>
              </p>
              <div className="text-input-container margin-bottom">
                <Input
                  // placeholder={t(region + ':resources.feedback-section.placeholder')}
                  multiline
                  fullWidth
                  value={this.state.feedback_q2}
                  onChange={this.handleChange('feedback_q2')}
                  rows={6}
                  classes={{root: "text-input-root"}}
                  // style={{ width: '100%'}}
                  >
                </Input>
              </div>

              <p>
                <strong>
                  {t(region + ':resources.feedback-section.question-three')}
                </strong>
              </p>
              <div className="text-input-container margin-bottom">
                <Input
                  // placeholder={t(region + ':resources.feedback-section.placeholder')}
                  multiline
                  fullWidth
                  value={this.state.feedback_q3}
                  onChange={this.handleChange('feedback_q3')}
                  rows={6}
                  classes={{root: "text-input-root"}}
                  // style={{ width: '100%'}}
                  >
                </Input>
              </div>

              <button className="resources-button" type='submit'  disabled={!this.state.feedback_q1 && !this.state.feedback_q2 && !this.state.feedback_q3}>
                {t(region + ':resources.feedback-section.submit')}
              </button>
            </form>
            {
              this.state.feedbackSuccess &&
                <div className="success-notification">
                  {t(region + ':resources.feedback-section.success')}
                </div>
            }
            {
              this.state.feedbackError &&
                <div className="error-notification">
                  {this.state.feedbackError}
                </div>
            }
          </div>


        </div>

        {/* <div className="volunteer-section" id="volunteer-block">
            <h1>
              {t(region + ':resources.volunteer-section.title')}
            </h1>
            <h2 className="subtitle">
              {t(region + ':resources.volunteer-section.subtitle')}
            </h2>
            <h3>
              {t(region + ':resources.volunteer-section.description')}
            </h3>

            <form onSubmit={this.submitVolunteer} className="form-container">
              <div className="text-input-container flat">
                <Input
                  placeholder={t(region + ':resources.volunteer-section.name-placeholder')}
                  fullWidth
                  disableUnderline
                  value={this.state.name}
                  onChange={this.handleChange('name')}
                  classes={{root: "text-input-root"}}
                  >
                </Input>
              </div>

              <div className="text-input-container flat">
                <Input
                  placeholder={t(region + ':resources.volunteer-section.contact-placeholder')}
                  multiline
                  rows={3}
                  disableUnderline
                  fullWidth
                  value={this.state.contact}
                  onChange={this.handleChange('contact')}
                  classes={{root: "text-input-root"}}
                  >
                </Input>
              </div>

              <button className="resources-button" type='submit' disabled={!this.state.name || !this.state.contact}>
                {t(region + ':resources.volunteer-section.submit')}
              </button>
              {
                this.state.volunteerSuccess &&
                  <div className="success-notification">
                    {t(region + ':resources.volunteer-section.success')}
                  </div>
              }
              {
                this.state.volunteerError &&
                  <div className="error-notification">
                    {this.state.volunteerError}
                  </div>
              }
            </form>
            

        </div> */}

        <div className="footer-section">
          <p>
            <strong>
              © 2021 The Brightly Project 
            </strong>
            <br />
            {t("email-us-footer")} <a href="mailto:info@thebrightlyproject.com">info@thebrightlyproject.com</a>
          </p>
        </div>


      </div>
    )
  }
}

const TranslatedResourcePage = translate(
  'translations', 
  { wait: true }
)(ResourcePage);

export default withCookies(
  compose(
    graphql(submitFeedback, {
      props: ({ mutate, ownProps }) => ({
        submitFeedback: ({ feedback, sessionId }) =>
          mutate({ 
            variables: { 
              feedback: feedback,
              session_id: sessionId,
            },
            errorPolicy: 'all'
          })
      })
    }),
    graphql(notifyResults, {
      props: ({ mutate, ownProps }) => ({
        notifyResults: ({ email, sessionId }) =>
          mutate({ 
            variables: { 
              email: email,
              session_id: sessionId,
            },
            errorPolicy: 'all'
          })
      })
    }),
  )(TranslatedResourcePage)
);


// WEBPACK FOOTER //
// ./src/pages/resources.js